// extracted by mini-css-extract-plugin
export default {"formContainer":"FormContainer_formContainer__rQtsg","iconContainer":"FormContainer_iconContainer__Kze+N","spin":"FormContainer_spin__CyjLg"};